(function () {
  'use strict';

  angular
    .module('app')
    .controller('B2bPartnersEditController', B2bPartnersEditController);

  B2bPartnersEditController.$inject = ['debug', '$stateParams', 'API', 'alert', 'i18n', '$scope', '$state', 'helpers',];

  function B2bPartnersEditController(debug, $stateParams, API, alert, i18n, $scope, $state, helpers) {
    var vm = this;
    vm.id = $stateParams.id;
    vm.isSaving = false;
    vm.save = save;
    vm.partner = {};
    vm.loadingState = {
      'partnerIsLoading': false,
    };
    vm.contracts = [];
    vm.groups = [];
    vm.teachers = [];
    vm.resourceExpand = 'campaign';
    vm.now = helpers.getDatabaseDatetime();
    vm.openCampaignModal = openCampaignModal;

    activate();

    function activate() {
      loadPartner();
    }

    function loadPartner() {
      vm.loadingState.partnerIsLoading = true;
      API.B2bPartners.get({
        id: vm.id,
        expand: vm.resourceExpand
      })
        .$promise
        .then(function (response) {
          debug.log(response);
          vm.partner = response;
          vm.campaign = angular.copy(response.campaign);
        }, function () {
        })
        .finally(function () {
          vm.loadingState.partnerIsLoading = false;
        });
    }

    function save() {
      if (!vm.isSaving) {
        vm.isSaving = true;

        var promise = vm.partner.$save({ expand: vm.resourceExpand });

        promise.then(function () {
          window.toast({
            message: i18n.get('SAVED'),
            autoRemoveTime: 5000,
            type: 'success'
          });
          vm.now = helpers.getDatabaseDatetime();
        }, function (response) {
          debug.log(response);
        })
          .finally(function () {
            vm.isSaving = false;
          });
      }
    }

    function openCampaignModal() {
      alert.prompt('select-campaign', { campaign: vm.campaign })
        .then(function (newCampaignId) {
          if (vm.partner.id) {
            API.B2bPartners.save({
              id: vm.partner.id,
              campaign_id: newCampaignId
            });
          }

          vm.partner.campaign_id = newCampaignId;
          vm.campaign = API.Campaign.get({ id: newCampaignId });

        }, function () {
        });
    }
  }
})();